import { FilterMultipleIcon } from './FilterMultipleIcon';

/**
 * author: Simran
 * id EC7474F7-BE1F-4076-8CDB-DD5779095168
 * name filter-multiple
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/filter-multiple.svg
 * tags
 */
export const FunnelMultipleIcon = FilterMultipleIcon;
export default FunnelMultipleIcon